<template>
  <div>
    <div class="user_content">
      <img src="../../assets/img/trustlook-logo.png" alt="" class="logo" />
      <div class="sign">
        <span @click="jump('/login')">{{ $t('user.SignIn') }}</span>
        <span ref="lang">
          <span @click="languageStatus = !languageStatus" class="choose icon-lang"></span>
          <el-collapse-transition>
            <ul class="language_selection" v-show="languageStatus">
              <li @click="switchLang('zh')" :class="{ active: lang === 'zh' }">中文</li>
              <li @click="switchLang('en')" :class="{ active: lang === 'en' }">English</li>
            </ul>
          </el-collapse-transition>
        </span>
      </div>
      <div class="tip_container">
        <img src="../../assets/img/tip.png" alt="" />
        <p>{{ $t('errMsg.tip2') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Message } from 'element-ui'
import VueRouter from 'vue-router'

const { isNavigationFailure, NavigationFailureType } = VueRouter

export default {
  name: 'tip',
  data() {
    return {
      languageStatus: false
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  methods: {
    jump(url) {
      this.$router.push(url).catch(err => {
        // to hide the below error message
        if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
          throw Error(err)
        }
      })
    },
    switchLang(lang) {
      if (lang === this.$store.state.lang) return
      this.$store.commit('switchLang', lang)
      this.languageStatus = false
      Message({ type: 'success', message: this.$t('message.switchSuccessfully'), showClose: true })
      location.reload()
    }
  },
  mounted() {
    let _this = this
    document.addEventListener('click', e => {
      if (!!_this.$refs.lang && !!_this.$refs.lang.contains(e.target)) return
      _this.languageStatus = false
    })
  }
}
</script>
<style lang="scss" src="./user.scss" scoped></style>
<style lang="scss" scoped>
.tip_container {
  & > img {
    display: block;
    width: 489px;
    height: 299px;
    margin: 0 auto 60px;
  }
  & > p {
    text-align: center;
    height: 22px;
    font-size: 18px;
    font-family: Metropolis-Medium;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 22px;
  }
}
@media screen and (max-width: 450px) {
  .tip_container {
    & > img {
      width: 200px;
      height: 122px;
      margin: 0 auto 40px;
    }
    & > p {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/tip.vue